import React, { Component } from "react";
import { Button, Checkbox, Col, Form, Input, Modal, Row, Select, Spin, Tooltip } from "antd";
import CloseIcon from "../../assets/fi_x-circle.svg";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import BunkeyAPI from "../../api/BunkeyAPI";
import { sendNotification } from "../../utils/index";
import { isEmail } from "../../utils/index";
import { setkeyboardEnabled } from "../../actions/AppAction";
import { sendShareAssets } from "../../actions/AssetsShareAction";
import Helper from "../helper/Helper";
// import { fetchUsersToMentionByAssets } from "../../api/GroupApi";
import { fetchUsersToMentionAll } from "../../api/GroupApi";
import { cancelSelect } from "../../actions/MultiselectAction";
import { isRightsDownloadBlocked } from "../../utils/rights";

const { Option } = Select;

const spinnerStyle = {
  textAlign: "center",
  borderRadius: 4,
  marginBottom: 20,
  padding: "30px 50px",
  margin: "20px 0",
};
class MultiShareModal extends Component {
  constructor(props) {
    super(props);

    this.myInputCopyLink = React.createRef();

    this.state = {
      emails: [],
      plainOptions: ["10", "30", "60", "90", "120"],
      selectedOption: "10",
      loadingButtonLink: false,
      showPasswordInputs: false,
      copyLink: "",
      addPassword: "",
      confirmPassword: "",
      showCopyLink: false,
      hasEmailError: false,
      message: "",
      isFetchingUsers: false,
      users: [],
      errorFetchingUsers: null,
      showSpinnerEmail: true
    };
  }

  isDownloadBlocked = items =>
    (items || []).some(item =>
      isRightsDownloadBlocked(item, this.props.modules)
    );

  notifyBlockedDownload = () => {
    sendNotification(
      "warning",
      this.props.intl,
      this.props.intl.formatMessage({ id: "rights_download_blocked" })
    );
  };

  handleSendShared = () => {
    const { selectedFiles, workclient, user, intl, itemShare } = this.props;
    const {
      message,
      emails,
      hasEmailError,
      showPasswordInputs,
      addPassword,
      confirmPassword,
      selectedOption
    } = this.state;

    if (this.isDownloadBlocked(selectedFiles)) {
      this.notifyBlockedDownload();
      return;
    }

    // added
    let ids = [];
    if (selectedFiles.length > 0 && itemShare === undefined) {
      ids = selectedFiles.map(e => e._id);
    } else if (itemShare.length > 0 && itemShare !== undefined) {
      ids = [...itemShare];
    }

    // const ids = selectedFiles.map(e => e._id);

    // Si agrego contraseña
    if (showPasswordInputs) {
      // Y estas coinciden
      if (
        addPassword === confirmPassword &&
        confirmPassword !== "" &&
        addPassword !== ""
      ) {
        // Si el correo tiene errores
        if (hasEmailError) {
          this.setState({
            hasEmailError: false
          });
          return;
        } else {
          // Si el email es valido
          if (emails.length > 0) {
            this.props.sendShareAssets(
              workclient,
              user,
              ids,
              message,
              confirmPassword,
              emails,
              intl,
              parseInt(selectedOption)
            );
            this.props.setkeyboardEnabled(false);
            this.setState({
              start: true
            });
          } else {
            sendNotification(
              "error",
              intl,
              intl.formatMessage({ id: "empty_email_share" })
            );
          }
        }
        // Si los inputs estan vacios
      } else if (addPassword === "" || confirmPassword === "") {
        sendNotification(
          "error",
          intl,
          intl.formatMessage({ id: "must_enter_password" })
        );
        //  O si no son iguales
      } else {
        sendNotification(
          "error",
          intl,
          intl.formatMessage({ id: "not_equal_passwords" })
        );
      }
      // Si no agrego contraseña
    } else if (hasEmailError) {
      this.setState({
        hasEmailError: false
      });
      return;
    } else {
      if (emails.length > 0) {
        this.props.sendShareAssets(
          workclient,
          user,
          ids,
          message,
          "",
          emails,
          intl,
          parseInt(selectedOption)
        );
        this.props.setkeyboardEnabled(false);
        this.setState({
          start: true
        });
      } else {
        sendNotification(
          "error",
          intl,
          intl.formatMessage({ id: "empty_email_share" })
        );
      }
    }
  };

  handleSendLinkShare = (items, user, changeSelectedOption) => {
    const { intl } = this.props;
    const { selectedOption, addPassword, confirmPassword } = this.state;

    if (this.isDownloadBlocked(items)) {
      this.notifyBlockedDownload();
      return;
    }

    if (
      (addPassword.length > 0 || confirmPassword.length > 0) &&
      addPassword !== confirmPassword
    ) {
      sendNotification("error", intl, intl.formatMessage({ id: "multi-share-unmatch-passwords" }));
      return;
    }

    const objects = items.map(e => e._id);

    this.setState(
      {
        loadingButtonLink: true
      },
      () =>
        BunkeyAPI({
          url: `/shared/getDownloadLink`,
          method: "POST",
          data: {
            object: objects,
            user: user,
            password: confirmPassword,
            expiresIn: changeSelectedOption ? parseInt(changeSelectedOption) : parseInt(selectedOption)
          }
        })
          .then(resp => {
            if (resp.data && resp.data.unavailable) {
              this.setState({ loadingButtonLink: false });
              this.notifyBlockedDownload();
              return;
            }
            this.setState({
              copyLink: resp.data,
              showCopyLink: true,
              loadingButtonLink: false
            });

            this.myInputCopyLink.focus();
            this.myInputCopyLink.input.setSelectionRange(0, 9999)
          })
          .catch(err => {
            console.log(err);
            this.setState({ loadingButtonLink: false });
            sendNotification(
              "error",
              intl,
              intl.formatMessage({ id: "error_copy_link" })
            );
          })
    );
  };

  handleOnInputChange = e => {
    this.setState({
      message: e.target.value
    });
  };

  handleChangeEmail = values => {
    const onlyValidEmails = values.filter(email => isEmail(email));
    this.setState({ emails: onlyValidEmails });
  };

  handleShowPasswordInputs = () => {
    const { showPasswordInputs } = this.state;
    this.setState({
      showPasswordInputs: !showPasswordInputs
    });
  };

  handleAddPass = e => {
    this.setState({
      addPassword: e.target.value
    });
  };

  handleConfirmPass = e => {
    this.setState({
      confirmPassword: e.target.value
    });
  };

  fetchUsers = () => {
    this.setState({ showSpinnerEmail: true })        
    // const { selectedFiles, workclient, itemShare } = this.props;
    const { workclient } = this.props;
    // let ids = [];
    // if (selectedFiles.length > 0 && itemShare === undefined) {
    //   ids = selectedFiles.map(e => e._id);
    // } else if (itemShare.length > 0) {
    //   ids = [...itemShare];
    // }

    // fetchUsersToMentionByAssets(workclient, ids)
    //   .then(res => {
    //     const adminUsers = [];
    //     const operatorUsers = [];
    //     console.log(res.data);
    //     for (let i = 0; i < res.data.length; i++) {
    //       const { adminUsers: adminU, operatorUsers: operatorU } = res.data[i];
    //       adminUsers.push(...adminU);
    //       operatorUsers.push(...operatorU);
    //     }
    //     const usersMentions = [...adminUsers, ...operatorUsers];
    //     const filteredData = Array.from(
    //       new Set(usersMentions.map(obj => obj._id))
    //     ).map(id => usersMentions.find(obj => obj._id === id));
    //     const usersMentionsSorted = filteredData.sort(
    //       (firstUser, secondUser) => {
    //         if (firstUser.name.toLowerCase() < secondUser.name.toLowerCase())
    //           return -1;
    //         if (firstUser.name.toLowerCase() === secondUser.name.toLowerCase())
    //           return 0;
    //         return 1;
    //       }
    //     );

    //     this.setState({ 
    //       users: usersMentionsSorted,
    //       showSpinnerEmail: false 
    //      });
    //   })
    //   .catch(err => {
    //     this.setState({ 
    //       errorFetchingUsers: err,
    //       showSpinnerEmail: false 
    //      });
    //   });
  
    fetchUsersToMentionAll(workclient, 1)
      .then(res => {
        // const { adminUsers, operatorUsers } = res.data;
        console.log(res.data);
        const usersMentions = res.data;
        const usersMentionsSorted = usersMentions.sort(
          (firstUser, secondUser) => {
            if (firstUser.name.toLowerCase() < secondUser.name.toLowerCase())
              return -1;
            if (firstUser.name.toLowerCase() === secondUser.name.toLowerCase())
              return 0;
            return 1;
          }
        );

        this.setState({
          users: usersMentionsSorted,
          isFetchingUsers: false,
          errorFetchingUsers: null,
          showSpinnerEmail: false
        });
      })
      .catch(err => {
        this.setState({
          errorFetchingUsers: err,
          isFetchingUsers: false,
          users: [],
          showSpinnerEmail: false
        });
      });
  };

  componentDidMount() {
    this.props.setkeyboardEnabled(true);
    this.fetchUsers();
  }

  render() {
    const {
      showModal,
      handleHiddenModal,
      user,
      intl,
      selectedFiles,
      sharing,
      itemShare,
    } = this.props;

    const {
      plainOptions,
      selectedOption,
      showCopyLink,
      copyLink,
      message,
      emails,
      users,
      showPasswordInputs,
      addPassword,
      confirmPassword,
      loadingButtonLink,
      showSpinnerEmail
    } = this.state;

    const optionsUser = users.map(user => {
      return (
        <Option key={user._id} value={user.email} uid={user._id}>
          {`${user.name} (${user.email})`}
        </Option>
      );
    });
    const optionsSpinner = 
      <Option key={'spinner_loading'} >
        <div style={spinnerStyle}>
          <Spin spinning={true} />
        </div>
      </Option>
    // added
    const totalFiles =
      selectedFiles.length > 0 ? selectedFiles.length : itemShare.length;

    return (
      <Modal
        visible={showModal}
        onCancel={handleHiddenModal}
        width={500}
        footer={null}
        centered
        closeIcon={<img src={CloseIcon} alt={"icon close"} />}
        className="share-modal"
      >
        <div className="share-modal-title">
          {intl.formatMessage({ id: "multi-share-share" })}
        </div>
        <div
          style={{
            color: "#6F6F6F",
            fontSize: 18,
            fontWeight: 400,
            marginBottom: 26
          }}
        >
          {intl.formatMessage({ id: "multi-share-sharing" })} {totalFiles}{" "}
          {totalFiles === 1 ? intl.formatMessage({ id: "multi-share-sharing-item" }) : intl.formatMessage({ id: "multi-share-sharing-items" })}
        </div>

        <Row style={{ marginBottom: 0 }}>
          <Form>
            <Form.Item label={intl.formatMessage({ id: "multi-share-share-days" })}>
              <Row style={{ width: "100%" }}>
                {plainOptions.map(item => {
                  return (
                    <Col span={4} key={item}>
                      <Checkbox
                        value={item}
                        onChange={value => {
                          if (selectedOption !== item && showCopyLink) {
                            if (selectedFiles.length > 0) {
                              this.handleSendLinkShare(selectedFiles, user, value.target.value);
                            } else {
                              this.handleSendLinkShare([{ _id: itemShare }], user, value.target.value);
                            }
                          }
                          this.setState({
                            selectedOption: value.target.value
                          });
                        }}
                        checked={selectedOption === item}
                      >
                        {item}
                      </Checkbox>
                    </Col>
                  );
                })}
              </Row>
            </Form.Item>
            <Form.Item>
              <Tooltip
                title={
                  this.isDownloadBlocked(selectedFiles)
                    ? intl.formatMessage({ id: "rights_asset_out" })
                    : null
                }
              >
                <span>
                  <Button
                    size={"large"}
                    htmlType={"button"}
                    type={"primary"}
                    loading={loadingButtonLink}
                    disabled={this.isDownloadBlocked(selectedFiles)}
                    className="share-modal-button"
                    onClick={() => {
                      if (selectedFiles.length > 0) {
                        this.handleSendLinkShare(selectedFiles, user);
                      } else {
                        this.handleSendLinkShare([{ _id: itemShare }], user);
                      }
                    }}
                  >
                    {intl.formatMessage({ id: "multi-share-share-generate" })}
                  </Button>
                </span>
              </Tooltip>
            </Form.Item>
            {showCopyLink && (
              <Form.Item style={{ marginBottom: 18 }}>
                <Input.Group compact size={"large"}>
                  <Input
                    style={{ width: "70%" }}
                    ref={ref => this.myInputCopyLink = ref}
                    type="text"
                    value={copyLink}
                    readOnly
                  />
                  <Button
                    size={"large"}
                    type={"primary"}
                    style={{ width: "30%" }}
                    onClick={() => {
                      navigator.clipboard.writeText(copyLink);
                      sendNotification(
                        "success",
                        intl,
                        intl.formatMessage({ id: "link_copied" })
                      );
                      this.props.cancelSelect()
                      handleHiddenModal()
                    }}
                  >
                    {intl.formatMessage({ id: "multi-share-share-copy" })}
                  </Button>
                </Input.Group>
              </Form.Item>
            )}
            <Form.Item label={intl.formatMessage({ id: "add_email" })}>
              <Select
                mode="tags"
                style={{ width: "100%" }}
                onChange={this.handleChangeEmail}
                tokenSeparators={[","]}
                value={emails}
              >
                {showSpinnerEmail && optionsSpinner}
                {optionsUser}
              </Select>
            </Form.Item>
            <Form.Item>
              <Checkbox onChange={this.handleShowPasswordInputs}>
                {intl.formatMessage({ id: "add_password" })}
                <Helper
                  title={"helper_title"}
                  content={"helper_add_password"}
                  trigger={`click`}
                />
              </Checkbox>
              {showPasswordInputs && (
                <Input.Group className="input-group">
                  <Input.Password
                    className="pass-input"
                    placeholder={intl.formatMessage({ id: "add_password" })}
                    value={addPassword}
                    autoComplete="new-password"
                    onChange={this.handleAddPass}
                  />
                  <Input.Password
                    className="pass-input"
                    placeholder={intl.formatMessage({ id: "confirm_password" })}
                    value={confirmPassword}
                    autoComplete="new-password"
                    onChange={this.handleConfirmPass}
                  />
                </Input.Group>
              )}
            </Form.Item>
            <Form.Item label={intl.formatMessage({ id: "message" })}>
              <Input.TextArea
                placeholder={intl.formatMessage({ id: "message" })}
                rows={5}
                value={message}
                onChange={this.handleOnInputChange}
              />
            </Form.Item>
          </Form>
        </Row>

        <Row type={"flex"} justify={"space-between"}>
          <Button
            size={"large"}
            type={"primary"}
            className="share-modal-button accept"
            onClick={this.handleSendShared}
            loading={sharing}
          >
            {intl.formatMessage({id: "shared_share"})}
          </Button>
          <Button
            size={"large"}
            type={"primary"}
            ghost
            onClick={handleHiddenModal}
            className="share-modal-button cancel"
          >
            {intl.formatMessage({id: "cancel_button"})}
          </Button>
        </Row>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    selectedFiles: state.selectedFiles.data,
    user: state.authUser.user._id,
    workclient: state.client.data ? state.client.data._id : null,
    sharing: state.assetsShared.sharing,
    newColor: state.authUser.user && state.authUser.user.color ? state.authUser.user.color : '#2E97CF',
    modules: state.client.data ? state.client.data.modules : [],
  };
};

const mapDispatchToProps = {
  setkeyboardEnabled,
  sendShareAssets,
  cancelSelect
};

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(MultiShareModal))
);
